<script setup lang="ts">
/**
 * Directors' Circular Resolution (Transfer) — 이사 회람 결의 (with SC: 주권 반납·소각 + 신주권 재발행).
 * · sole/multiple + 결의근거 = TransferDcrIntro
 * · 신주권 발행 방식: Common Seal 날인 vs Section 66 서명 토글 (sole/basis 연동)
 */
import { computed, inject } from 'vue';
import { TRANSFER_DOC_CTX } from './transferContext';
import TransferDocVarField from './TransferDocVarField.vue';
import TransferDocHead from './parts/TransferDocHead.vue';
import TransferDcrIntro from './parts/TransferDcrIntro.vue';
import TransferTable from './parts/TransferTable.vue';
import TransferSigners from './parts/TransferSigners.vue';

const ctx = inject(TRANSFER_DOC_CTX)!;
const hasSeal = computed(() => ctx.flag('has_common_seal'));
const isMultiple = computed(() => ctx.flag('is_multiple_director_company'));
const basis = computed(() => ctx.choiceOf('resolution_basis') || 'constitution');
const basisSeal = computed(() =>
  basis.value === 'articles' ? "the Company's Articles of Association"
  : basis.value === 'third_schedule' ? 'the Companies Act 2016'
  : "the Company's Constitution");
</script>

<template>
  <div class="allot-doc">
    <TransferDocHead :show-reg="false" />
    <TransferDcrIntro />

    <p class="doc-sec-title">TRANSFER OF SHARES</p>
    <p class="doc-p">That the Company be and is hereby authorised to approve the transfer of the following shares with immediate effect :-</p>

    <TransferTable />

    <p class="doc-p" style="margin-top:12px">
      THAT upon lodgement of the duly executed and stamped instrument of transfers with the Company pursuant to Section 105 of the
      Companies Act 2016 ("the Act"), the related share certificate(s) in the name of the transferor(s) be cancelled and the Secretary be
      authorized to enter the name of the transferee(s) in the register of members as member(s) pursuant to Section 102 of the Act.
    </p>
    <p class="doc-p">
      FURTHER RESOLVED THAT the Secretary be authorized to issue new share certificate(s) in the name of the transferee(s), and that the new
      share certificate(s) be
      <span class="doc-toggle" title="Common Seal / Section 66 signing" @click="ctx.toggleFlag('has_common_seal')">{{ hasSeal ? 'executed by affixing the Common Seal' : 'signed in accordance with Section 66 of the Companies Act 2016' }}</span>
      <template v-if="hasSeal"> of the Company in accordance with {{ basisSeal }}.</template>
      <template v-else>, {{ isMultiple ? 'by any two authorised officers of the Company, one of whom shall be a director' : 'by the sole director in the presence of a witness who attests the signature' }}.</template>
    </p>
    <p class="doc-p">
      AND RESOLVED THAT the Secretary be and is hereby authorized and empowered to notify the Registrar of Companies in compliance with
      Section 51 of the Act of the changes to the Register of Members arising from the above transfer of shares for and on behalf of the Company.
    </p>

    <p class="doc-lbl-title">BOARD OF DIRECTORS</p>
    <TransferSigners var-key="dcr" board-label="BOARD OF DIRECTORS" />
    <p class="doc-p" style="margin-top:14px"><b>Date:</b> <TransferDocVarField field-key="resolution_date" /></p>
  </div>
</template>
